/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  AIAccessGrantCreateDTO,
  AIAccessGrantDTO,
  AIAccessGrantExtendDTO,
  AIAccessGrantListDTO,
  HTTPValidationError,
  MCPConnectionInfoDTO,
} from '../fastAPI.schemas'

/**
 * @summary Connection Info
 */
export const connectionInfo = (signal?: AbortSignal) => {
  return customInstance<MCPConnectionInfoDTO>({
    url: `/ai-access/connection-info`,
    method: 'GET',
    signal,
  })
}

export const getConnectionInfoQueryKey = () => {
  return [`/ai-access/connection-info`] as const
}

export const getConnectionInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof connectionInfo>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof connectionInfo>>, TError, TData>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getConnectionInfoQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof connectionInfo>>> = ({ signal }) =>
    connectionInfo(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof connectionInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ConnectionInfoQueryResult = NonNullable<Awaited<ReturnType<typeof connectionInfo>>>
export type ConnectionInfoQueryError = unknown

/**
 * @summary Connection Info
 */

export function useConnectionInfo<
  TData = Awaited<ReturnType<typeof connectionInfo>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof connectionInfo>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConnectionInfoQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary List Grants
 */
export const listGrants = (signal?: AbortSignal) => {
  return customInstance<AIAccessGrantListDTO>({ url: `/ai-access/grants`, method: 'GET', signal })
}

export const getListGrantsQueryKey = () => {
  return [`/ai-access/grants`] as const
}

export const getListGrantsQueryOptions = <
  TData = Awaited<ReturnType<typeof listGrants>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListGrantsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listGrants>>> = ({ signal }) =>
    listGrants(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listGrants>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ListGrantsQueryResult = NonNullable<Awaited<ReturnType<typeof listGrants>>>
export type ListGrantsQueryError = unknown

/**
 * @summary List Grants
 */

export function useListGrants<
  TData = Awaited<ReturnType<typeof listGrants>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listGrants>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListGrantsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Create Grant
 */
export const createGrant = (
  aIAccessGrantCreateDTO: AIAccessGrantCreateDTO,
  signal?: AbortSignal,
) => {
  return customInstance<AIAccessGrantDTO>({
    url: `/ai-access/grants`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: aIAccessGrantCreateDTO,
    signal,
  })
}

export const useCreateGrantMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGrant>>,
    TError,
    { data: AIAccessGrantCreateDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGrant>>,
  TError,
  { data: AIAccessGrantCreateDTO },
  TContext
> => {
  const mutationKey = ['createGrant']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGrant>>,
    { data: AIAccessGrantCreateDTO }
  > = props => {
    const { data } = props ?? {}

    return createGrant(data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/ai-access/grants` },
    { operationId: 'create_grant_ai_access_grants_post', operationName: 'createGrant' },
  )

  return customOptions
}

export type CreateGrantMutationResult = NonNullable<Awaited<ReturnType<typeof createGrant>>>
export type CreateGrantMutationBody = AIAccessGrantCreateDTO
export type CreateGrantMutationError = HTTPValidationError

/**
 * @summary Create Grant
 */
export const useCreateGrant = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGrant>>,
    TError,
    { data: AIAccessGrantCreateDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createGrant>>,
  TError,
  { data: AIAccessGrantCreateDTO },
  TContext
> => {
  const mutationOptions = useCreateGrantMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Revoke Grant
 */
export const revokeGrant = (grantId: string) => {
  return customInstance<unknown>({ url: `/ai-access/grants/${grantId}`, method: 'DELETE' })
}

export const useRevokeGrantMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeGrant>>,
    TError,
    { grantId: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeGrant>>,
  TError,
  { grantId: string },
  TContext
> => {
  const mutationKey = ['revokeGrant']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeGrant>>,
    { grantId: string }
  > = props => {
    const { grantId } = props ?? {}

    return revokeGrant(grantId)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/ai-access/grants/{grantId}` },
    {
      operationId: 'revoke_grant_ai_access_grants__grant_id__delete',
      operationName: 'revokeGrant',
    },
  )

  return customOptions
}

export type RevokeGrantMutationResult = NonNullable<Awaited<ReturnType<typeof revokeGrant>>>

export type RevokeGrantMutationError = HTTPValidationError

/**
 * @summary Revoke Grant
 */
export const useRevokeGrant = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeGrant>>,
    TError,
    { grantId: string },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeGrant>>,
  TError,
  { grantId: string },
  TContext
> => {
  const mutationOptions = useRevokeGrantMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Extend Grant
 */
export const extendGrant = (grantId: string, aIAccessGrantExtendDTO: AIAccessGrantExtendDTO) => {
  return customInstance<AIAccessGrantDTO>({
    url: `/ai-access/grants/${grantId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: aIAccessGrantExtendDTO,
  })
}

export const useExtendGrantMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extendGrant>>,
    TError,
    { grantId: string; data: AIAccessGrantExtendDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof extendGrant>>,
  TError,
  { grantId: string; data: AIAccessGrantExtendDTO },
  TContext
> => {
  const mutationKey = ['extendGrant']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extendGrant>>,
    { grantId: string; data: AIAccessGrantExtendDTO }
  > = props => {
    const { grantId, data } = props ?? {}

    return extendGrant(grantId, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/ai-access/grants/{grantId}` },
    { operationId: 'extend_grant_ai_access_grants__grant_id__patch', operationName: 'extendGrant' },
  )

  return customOptions
}

export type ExtendGrantMutationResult = NonNullable<Awaited<ReturnType<typeof extendGrant>>>
export type ExtendGrantMutationBody = AIAccessGrantExtendDTO
export type ExtendGrantMutationError = HTTPValidationError

/**
 * @summary Extend Grant
 */
export const useExtendGrant = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extendGrant>>,
    TError,
    { grantId: string; data: AIAccessGrantExtendDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof extendGrant>>,
  TError,
  { grantId: string; data: AIAccessGrantExtendDTO },
  TContext
> => {
  const mutationOptions = useExtendGrantMutationOptions(options)

  return useMutation(mutationOptions)
}
